import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const updateUnitActivation = async (model: IActivationServiceRequestModel): Promise<IActivationServiceRequestModel> =>
  axios.post(`/UnitActivation/updateunitactivationrequest`, model).then((res) => res?.data?.data)

type Props = {
  model: IActivationServiceRequestModel
}

export const useUpdateUnitActivation = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestModel) => void) =>
  useMutation({
    mutationKey: ['updateUnitActivation'],
    mutationFn: ({ model }: Props) => updateUnitActivation(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated device activation.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update device activation, please try again.')
      }
    },
    throwOnError: false
  })
